import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { uropProjects } from '../assets/urop_projects/uropProjects';
import {
  UropProject,
  UropProjects,
  UropState,
  SearchQuery,
} from '../types';

// helper function to search UROP projects
const searchArray = (
  arr: UropProjects,
  query: string
): UropProjects => {
  return arr.filter((project: UropProject): boolean => {
    if (project.title.toLowerCase().includes(query.toLowerCase())) {
      return true;
    } else if (
      project.description.toLowerCase().includes(query.toLowerCase())
    ) {
      return true;
    } else if (
      project.semester.toLowerCase().includes(query.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  });
};

const refineResults = (query: SearchQuery): UropProjects => {
  const queryArray = query.trim().split(/\s+/);
  let result = [...uropProjects];
  queryArray.forEach((query: string) => {
    result = searchArray(result, query);
  });
  return result;
};

const uropState: UropState = {
  displayProjects: uropProjects,
  searchQuery: '',
};

const uropSlice = createSlice({
  name: 'searchUrop',
  initialState: uropState,
  reducers: {
    searchUrop: (state, action: PayloadAction<string>): void => {
      state.searchQuery = action.payload; // update state of search queries
      state.displayProjects = refineResults(action.payload);
    },
  },
});

export const { searchUrop } = uropSlice.actions;

export default uropSlice.reducer;
